export default __webpack_public_path__ + "60d5819.png";